module.exports = __webpack_public_path__ + "static/media/18ECA11.05c8c493.jpg";